
import SearchInputField from '~/components/Common/UI/Search/SearchInputField'

export default {
    name: 'CorpSearch',
    components: {
        SearchInputField,
    },
}
